<template>
  <div>
    <div class="row mb-20">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="th-breadcrumb">
          <strong> <router-link tag="a" class :to="{ name: `${isTestPortal ? TEST_PORTAL_SUFFIX_CONST : ''}study-participant-appointments` }">Telehealth</router-link>&nbsp;/ Availability </strong>
          <div class="status-legends pull-right d-none">
            <span class="mr-15"> <span class="badge badge-success mr-3">&nbsp;</span> Completed </span>
            <span class="mr-15"> <span class="badge badge-danger mr-3">&nbsp;</span> Missed </span>
            <span> <span class="badge badge-primary mr-3">&nbsp;</span> Scheduled </span>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="availability-container">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 pr-0">
          <div class="availability">
            <div class="pt-22 pb-18 ava-title">
              <div class="row">
                <div class="col-sm-1 col-md-1 col-lg-2 pl-23">
                  <strong>Availability</strong>
                </div>
                <div class="col-sm-9 col-md-9 col-lg-8 weekly-navigation text-center">
                  <div v-if="isLoadingAvailability">Loading...</div>
                  <div v-if="!isLoadingAvailability">
                    <span @click="previousWeekList" class="fa fa-chevron-left"></span>

                    <span class="week-date ml-12 mr-12 text-uppercase ">{{ weekDateString }}</span>

                    <span @click="nextWeekList" class="fa fa-chevron-right"></span>
                  </div>
                </div>
                <div class="col-sm-2 col-md-2 col-lg-2 text-right">
                  <button class="btn btn-outline-primary btn-sm today-btn" @click="displayCurrentWeek">
                    Today
                  </button>
                </div>
              </div>
            </div>
            <div class="availability-lists">
              <div class="btn-box">
                <button type="button" class="btn btn-outline-primary btn-sm pull-left-" @click="showAvailabilityModal">
                  New Availability
                </button>
                <button type="button" class="btn btn-outline-primary btn-sm setting-btn pull-right- ml-10" @click="showSettingModal">
                  Settings
                </button>
              </div>
              <div class="clearfix"></div>
              <div v-if="availabilityList.length > 0" class="ava-list-container">
                <div class="availability-details" :class="{ disabled: availability.isDisabled }" v-for="availability in availabilityList" :key="availability.id" v-on="!availability.isDisabled ? { click: () => editAvailability(availability) } : {}">
                  <div>
                    <strong>{{ availability.title }}</strong>
                  </div>
                  <div>{{ availability.days }}</div>
                  <div>{{ availability.time }}</div>
                  <div class="mt-5" v-if="availability.exclude">Exclude: {{ availability.exclude }}</div>
                </div>
              </div>
              <div v-else class="response-msg">
                <div class="text-muted p-20 text-center align-middle">
                  {{ availabilityListRecordMsg }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Add/Edit availability modal-->
    <availabilityModal ref="availabilityModal" @refreshList="refreshAvailabiliies" @resetAvailabilityData="resetAvailabilityDataObject" :availabilityData="editAvailabilityObj" />
    <settingsModal ref="settingModalPopup"></settingsModal>
  </div>
</template>

<script>
import _ from "lodash";
import toastr from "toastr";
import moment from "moment";
import { mapGetters } from "vuex";

import availabilityModal from "./availability-modal";
import settingsModal from "./settings-modal";
import { TEST_PORTAL_SUFFIX } from "@/constants/config";

export default {
  name: "tele-health-availability",
  data() {
    return {
      studyId: this.$route.params.studyId,
      availabilityList: [],
      editAvailabilityObj: null,
      settingsDataObj: null,
      availabilityListRecordMsg: "Loading...",
      weekStartDate: moment()
        .utc()
        .startOf("week"),
      WeekEndDate: moment()
        .utc()
        .endOf("week"),
      isLoadingAvailability: false,
      TEST_PORTAL_SUFFIX_CONST: TEST_PORTAL_SUFFIX
    };
  },
  components: {
    availabilityModal,
    settingsModal
  },
  mounted() {
    //Load all the appointments from backend
    this.getAvailabilities();
  },
  computed: {
    ...mapGetters(["user"]),
    weekDateString() {
      const wsd = this.weekStartDate.format("DD MMM");
      const wed = this.WeekEndDate.format("DD MMM");
      const wy = this.WeekEndDate.format("YYYY");

      return `${wsd} - ${wed}, ${wy}`;
    },
    isTestPortal() {
      return (this.$route.name || this.$route.currentRoute.name || "").includes(TEST_PORTAL_SUFFIX);
    }
  },
  methods: {
    getAvailabilities() {
      const self = this;
      self.isLoadingAvailability = true;

      const st = this.weekStartDate.format("DD MMM YYYY hh:mm A");
      const ed = this.WeekEndDate.format("DD MMM YYYY hh:mm A");

      const weekFrom = moment(st, "DD MMM YYYY hh:mm A").utc();
      const weekTo = moment(ed, "DD MMM YYYY hh:mm A").utc();

      const getParams = {
        pId: this.user.id,
        startDate: weekFrom.valueOf(),
        endDate: weekTo.valueOf(),
        siteId: this.user.siteIds ? this.user.siteIds[0] : null,
        studyId: this.studyId
      };
      this.$api.getTelehealthAvailabilityList(getParams).then(
        response => {
          self.isLoadingAvailability = false;
          self.availabilityList = []; //Reset to empty other wise on refreshList event, records will get duplicate
          const availabilityResponse = response.body;
          if (availabilityResponse.length == 0) {
            self.availabilityListRecordMsg = "Please set up your site's availability.";
            return;
          }

          _.forEach(availabilityResponse, function(availabilityObject) {

            if (moment(availabilityObject.availabilityDate, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
              availabilityObject.availabilityDate = moment(availabilityObject.availabilityDate, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
            }
            
            const appointmentDateTimeString = availabilityObject.availabilityDate + " " + availabilityObject.fromTime;

            const availabilityDateUTC = moment.utc(appointmentDateTimeString);

            const availabilityDateLocal = availabilityDateUTC.local();

            const avaiTitle = availabilityDateLocal.format("DD MMM YYYY");

            const avaiDays = availabilityDateLocal.format("ddd");

            const avaiFromTimeUTC = moment.utc(availabilityObject.fromTime, "HH:mm:ss");
            const avaiFromTimeLocal = avaiFromTimeUTC.local();
            const avaiFromTime = avaiFromTimeLocal.format("hh:mm A");
            const avaiToTimeUTC = moment.utc(availabilityObject.toTime, "HH:mm:ss");
            const avaiToTimeLocal = avaiToTimeUTC.local();
            const avaiToTime = avaiToTimeLocal.format("hh:mm A");

            self.availabilityList.push({
              id: availabilityObject.id,
              title: avaiTitle,
              days: avaiDays,
              time: `${avaiFromTime} - ${avaiToTime}`,
              startDate: availabilityDateUTC.format(),
              type: availabilityObject.availabilityType ? availabilityObject.availabilityType : "single",
              isDisabled: availabilityDateLocal.isBefore(moment().format("DD MMM YYYY")),
              isSlotBooked: availabilityObject.isSlotBooked
            });
          });
        },
        error => {
          self.isLoadingAvailability = false;
          const errMsg = "Error while getting the availability list!";
          self.availabilityListRecordMsg = errMsg;
          toastr.error(error.body && error.body.message ? error.body.message : errMsg);
        }
      );
    },
    showAvailabilityModal() {
      this.editAvailabilityObj = null;
      this.$refs.availabilityModal.show();
    },
    showSettingModal() {
      this.$refs.settingModalPopup.show();
    },
    editAvailability(availabilityObj) {
      this.editAvailabilityObj = availabilityObj;
      this.$refs.availabilityModal.show();
    },
    refreshAvailabiliies(jumpDate) {
      if (jumpDate) {
        this.weekStartDate = moment(jumpDate)
          .utc()
          .startOf("week");
        this.WeekEndDate = moment(jumpDate)
          .utc()
          .endOf("week");
      }
      //Re Load all the availabilities list/calendar as the new/update action is performed
      this.getAvailabilities();
    },
    displayCurrentWeek() {
      this.weekStartDate = moment()
        .utc()
        .startOf("week");
      this.WeekEndDate = moment()
        .utc()
        .endOf("week");
      //Load the Availabilities
      this.getAvailabilities();
    },
    previousWeekList() {
      const pw = this.weekStartDate.subtract(1, "days");

      this.weekStartDate = moment(pw)
        .utc()
        .startOf("week");
      this.WeekEndDate = moment(pw)
        .utc()
        .endOf("week");
      //Load the Availabilities
      this.getAvailabilities();
    },
    nextWeekList() {
      const nw = this.WeekEndDate.add(1, "days");

      this.weekStartDate = moment(nw)
        .utc()
        .startOf("week");
      this.WeekEndDate = moment(nw)
        .utc()
        .endOf("week");
      //Load the Availabilities
      this.getAvailabilities();
    },
    resetAvailabilityDataObject() {
      this.editAvailabilityObj = null;
    }
  }
};
</script>
<style scoped lang="scss">
.paddings {
  padding: 20px;
}

.availability {
  font-family: Lato-Regular;
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  color: #4a4a4a;
}

.status-legends {
  font-size: 12px;
  color: #4a4a4a;

  & .badge {
    width: 12px;
    height: 12px;
    border-radius: 2px;
    vertical-align: text-top;
  }

  .badge-success {
    background-color: #2ecd71;
  }

  .badge-danger {
    background-color: #e74c3c;
  }

  .badge-primary {
    background-color: #34537d;
  }
}

.ava-title {
  border-bottom: solid 1px #e4e8eb;
}

.btn-box {
  padding: 17px 20px;
  overflow: hidden;
}

.ava-list-container {
  height: -moz-calc(100vh - 296px);
  height: -webkit-calc(100vh - 296px);
  height: calc(100vh - 296px);
  overflow-y: auto;
}

.availability-details {
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  margin: 20px;
  padding: 10px 11px;
  transition: all 250ms cubic-bezier(0.02, 0.01, 0.47, 1);
}

.availability-details:first-of-type {
  margin-top: 5px;
}

.availability-details.disabled {
  opacity: 0.7;
  background: #e4e8eb;
}

.availability-details:not(.disabled):hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transform: translate(0, -5px);
  transition-delay: 0s !important;
}

.btn-box button {
  padding: 0.25rem 0.97rem;
  font-size: 0.75rem;
  font-weight: bold;
}

.btn-box .setting-btn {
  padding: 0.25rem 1.875rem;
}

.calendar-view {
  border-right: 1px solid #e4e8eb;
  border-left: 0;
}

.calendar-view .calendar {
  min-height: 583px;
  border-top: 1px solid #e4e8eb;
}

.btn-outline-primary {
  color: #1e8fe1;
  border-color: #1e8fe1;
}

.btn-outline-primary:hover {
  background-color: #1e8fe1;
  color: #fff;
}

.calendar-header .today-btn {
  padding: 0.25rem 1.7rem;
  font-size: 0.75rem;
  font-weight: bold;
}
.calendar-header .row {
  width: 100%;
}
.weekly-navigation {
  font-weight: bold;
}
.weekly-navigation .fa {
  color: #007bff;
  cursor: pointer;
}

.response-msg {
  height: -moz-calc(100vh - 296px);
  height: -webkit-calc(100vh - 296px);
  height: calc(100vh - 296px);
}
</style>
